import axios from 'axios'
import {API_URL, RD_SURVEYS} from '../actionTypes/index'

const getToken = () => {
  return localStorage.getItem(process.env.REACT_APP_USERTOKEN)
}

const authHeaders = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${getToken()}`
})

// S2B surveys the RD can take now (matched on the survey's audience filters)
export const getRdSurveys = () => async (dispatch) => {
  dispatch({type: RD_SURVEYS.REQUEST})
  try {
    const {data} = await axios.get(`${API_URL}rd/s2b/surveys`, {headers: authHeaders()})
    dispatch({type: RD_SURVEYS.SUCCESS, payload: data})
  } catch (error) {
    dispatch({type: RD_SURVEYS.ERROR, payload: error})
  }
}

// Mints a single-use entry token and resolves with the S2B URL to send the RD to
export const startRdSurvey = async (surveyId) => {
  const {data} = await axios.post(
    `${API_URL}rd/s2b/surveys/${encodeURIComponent(surveyId)}/start`,
    {},
    {headers: authHeaders()}
  )
  return data?.data?.url
}
